import React from "react"
import { TitleWrapper } from "../elements"

export const Title = ({ children }) => {
  return <TitleWrapper>{children}</TitleWrapper>
}
